import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from '../services';

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
  constructor(private sessionService: SessionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.sessionService.isExpired() && !req.url.includes('assets/icons') && !req.url.includes('./assets/')) {
      req = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + this.sessionService.loginResponse.access_token),
      });
    }
    return next.handle(req);
  }
}
